import { Button, Typography } from "@mui/material"
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import SignOutModal from "../LogoutModal";
import { useEffect, useState } from 'react'
export default function LogoutButton(props) {
    const [open, setOpen] = useState(false)

    function handleClick() {
        setOpen(val => !val)
    }

    return (
        <Button
            variant="contained"
            disableElevation
            color="sdeBlue"
            size="small"
            sx={{ "&:hover": { backgroundColor: "sdeBlue.light" } }}
            onClick={() => handleClick()}>
            <LogoutRoundedIcon fontSize="small" sx={{ color:"#fff" }} />
                <Typography variant="body2" sx={{ color:"#fff" }}>Sign out</Typography>
            {open ? <SignOutModal /> : null}
        </Button>
    )
}